import MascotSVG from './MascotSVG';
import { useLang } from '../i18n';

const PHONE_HREF = 'tel:+18059229684';

function PhoneIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.66h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-1.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  );
}

export default function FinalCTA() {
  const { t } = useLang();

  return (
    <section className="final-cta-section sm-section" data-testid="final-cta" style={{ borderTop: '1px solid var(--sm-border)' }}>
      <div className="sm-container">
        <div className="final-cta-inner">
          <div className="final-cta-content">
            <div className="section-label">{t.ctaLabel}</div>
            <h2 className="final-cta-h2">
              {t.ctaH2_1}<br /><span style={{ color: 'var(--sm-red)' }}>{t.ctaH2_2}</span>
            </h2>
            <p className="final-cta-sub">{t.ctaBody}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%' }}>
              <a href={PHONE_HREF} className="btn-primary btn-lg btn-pulse" data-testid="final-call-cta" style={{ justifyContent: 'center', fontSize: '18px', padding: '1.1rem 2rem' }}>
                <PhoneIcon /> {t.ctaPhone}
              </a>
              <p style={{ fontSize: '13px', color: 'var(--sm-muted)', textAlign: 'center', margin: 0, fontFamily: 'Archivo, sans-serif', fontWeight: 600 }}>
                {t.ctaAddress}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
